import React, { useState } from 'react';
import {
  TextField,
  DetailsList,
  PrimaryButton,
  Stack,
  Text,
  SelectionMode,
} from 'office-ui-fabric-react';
import { useDispatch } from 'react-redux';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib-amd';
import { fetchTransactionRates } from '../../actions/rates';
import styles from './DriTransactionRates.styles';
import { showFlashMessage } from '../../actions/ui';
import useAPI from '../../hooks/useAPI';
import theme from '../../theme.style';

const tryParse = str => {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
};

const columns = [
  {
    key: 'contractName',
    fieldName: 'contractName',
    name: 'Contract Name',
  },
  {
    key: 'contractId',
    fieldName: 'contractId',
    name: 'Contract Id',
    minWidth: 150,
  },
  {
    key: 'agreementName',
    fieldName: 'agreementName',
    name: 'Agreement Name',
    minWidth: 250,
  },
  {
    key: 'rateAssignmentFilterId',
    fieldName: 'rateAssignmentFilterId',
    name: 'Rate Assignment Filter Id',
    minWidth: 250,
  },
];

const DriTransactionRates = () => {
  const [transactionInputText, setTransactionInputText] = useState(null);
  const transactionRates = useAPI(transaction => fetchTransactionRates(transaction), [], {
    fetchOnMount: false,
    autoFetch: false,
  });

  const dispatch = useDispatch();

  const onClickHandler = async () => {
    const parsed = tryParse(transactionInputText);
    if (parsed) {
      transactionRates.fetchApi(parsed);
    } else {
      dispatch(
        showFlashMessage('Could not parse input as JSON', { duration: 10000, type: 'error' }),
      );
    }
  };

  function renderResults() {
    if (transactionRates.isLoading) {
      return <Spinner size={SpinnerSize.Large} />;
    }

    const error = transactionRates.error?.body?.message || transactionRates.data?.error?.message;

    if (error) {
      let subtitle;
      if (transactionRates.error?.status === 422) {
        subtitle = 'Transaction does not match the expected schema. Details below.';
      }

      return (
        <Stack>
          <Text variant="large">Error Fetching rates</Text>

          {subtitle && <Text>{subtitle}</Text>}

          <Stack.Item style={{ color: theme.palette.accentError }}>
            <pre style={{ whiteSpace: 'break-spaces' }}>{error}</pre>
          </Stack.Item>
        </Stack>
      );
    }

    if (!transactionRates.data?.rates) {
      return null;
    }

    const rates = transactionRates.data.rates.map(r => ({
      contractName: r.contract.name,
      contractId: r.contract.contractId,
      agreementName: r.agreement.name,
      rateAssignmentFilterId: r.rateAssignment.filterId?.toString(),
      calcParams: r.rateAssignment.calcParams,
    }));

    return <DetailsList items={rates} columns={columns} selectionMode={SelectionMode.none} />;
  }

  return (
    <>
      <div className={styles.entryContainer}>
        <TextField
          label="Transaction"
          multiline
          rows={5}
          value={transactionInputText}
          resizable={false}
          className={styles.transactionField}
          onChange={(_, value) => setTransactionInputText(value)}
          disabled={transactionRates.isLoading}
        />
        <div className={styles.buttonContainer}>
          <PrimaryButton
            onClick={onClickHandler}
            text="Get Rates"
            disabled={transactionRates.isLoading}
          />
        </div>
      </div>
      {renderResults()}
    </>
  );
};

export default DriTransactionRates;
